// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__k1gW7","productName":"Table_productName__QbkUj"};